import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/LanguageContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export default function Terms() {
  const { t } = useI18n();
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    api.get("/legal/terms.json").then(({ data }) => setDoc(data)).catch(() => setDoc({ error: true }));
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="mx-auto max-w-3xl px-5 py-14 lg:py-20">
        <p className="label-eyebrow">{t("legal.eyebrow")}</p>
        <h1 className="mt-3 font-display text-3xl tracking-tight sm:text-4xl" data-testid="terms-title">
          {doc?.title || t("legal.terms")}
        </h1>
        {doc?.effective && (
          <p className="mt-3 text-sm text-slate-500">
            {t("legal.updated")}: {doc.effective}
          </p>
        )}

        {!doc && <p className="mt-10 text-slate-500" data-testid="terms-loading">{t("common.loading")}</p>}
        {doc?.error && <p className="mt-10 text-slate-500" data-testid="terms-error">{t("common.error")}</p>}

        {(doc?.sections || []).map((s, i) => (
          <section className="mt-10" key={s.heading || i} data-testid={`terms-section-${i + 1}`}>
            <h2 className="font-display text-xl tracking-tight sm:text-2xl">{s.heading}</h2>
            <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-600">
              {(s.paragraphs || []).map((p, j) => (
                <p key={`${s.heading || i}-${j}`}>{p}</p>
              ))}
            </div>
          </section>
        ))}

        {doc?.contact_email && (
          <p className="mt-10 text-sm text-slate-600">
            <a className="font-semibold text-sea underline" href={`mailto:${doc.contact_email}`} data-testid="terms-contact-email">
              {doc.contact_email}
            </a>
          </p>
        )}

        <div className="mt-14 flex gap-6 border-t border-slate-200 pt-8 text-sm font-semibold text-sea">
          <Link to="/" data-testid="terms-back-home" className="underline">{t("nav.book")}</Link>
          <Link to="/privacy" className="underline">{t("legal.privacyLink")}</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
